import api from "@/services/axios.js";
import {
  GenerateVerificationStagesPdfRequest,
  GenerateVerificationStagesPdfRequestPayload,
} from "../../types.ts";
import { searchHandler } from "../../lib/helpers.ts";

export const generateVerificationStagesPdf = (
  data: GenerateVerificationStagesPdfRequest,
) => {
  const payload: GenerateVerificationStagesPdfRequestPayload = {};

  if (data.selectingAll) {
    payload.searchVerificationsRequestViewModel = searchHandler(
      data.searchValues,
    );
  } else {
    payload.verificationStaesIds = data.verificationStaesIds;
  }

  return api.post(
    "/api/AdminVerification/generate-verification-stages-pdf",
    payload,
    { responseType: "blob" },
  );
};
